export default __webpack_public_path__ + "static/media/v3.fa2d0efd.jpg";